import { Theme } from "@mui/material";

export const spacing = {
  radius: {
    xxs: "8px",
    xs: "12px",
    sm: "16px",
    md: "24px",
  },
  padding: {
    xxs: "8px",
    xs: "16px",
    sm: "24px",
    md: "32px",
  },
};

export function highlightTextSx(theme: Theme, selected: boolean) {
  return {
    cursor: "pointer",
    fontSize: "inherit",
    lineHeight: "inherit",
    fontWeight: 800,
    borderRadius: spacing.radius.sm,
    border: `1px solid ${theme.palette.background.default}`,
    color: selected
      ? theme.palette.primary.contrastText
      : theme.palette.text.primary,
    backgroundColor: selected
      ? theme.palette.primary.main
      : theme.palette.primary.light,
  };
}
